export const NAMESPACE = "SendEmailModal";

export const MODES = {
  EMAIL: "email",
  SMS: "sms"
};

export const MESSAGE_WYSIWYG_EDITOR_FIELD_ID = "email-message";
export const MAX_LENGTH_SMS = 320;
